function convertToUppercase(value) {
  if (value) {
    return value.toUpperCase()
  }
  return value
}

export default convertToUppercase
